import getConfig from 'next/config'
import jwt from 'jsonwebtoken'

const createAuthToken = (user) => {
  const { serverRuntimeConfig } = getConfig()

  const email = user?.email || ''
  const emailDomain = email.split('@')?.[1] || null

  const payload = {
    authToken: user.authToken,
    emailDomain,
    username: user.username,
  }
  const options = {
    subject: `${user.id}`,
  }
  return jwt.sign(payload, serverRuntimeConfig.jwtSecret, options)
}

export default createAuthToken
